import React from 'react';
import AddOrderToBatchOrPrint from '../add-order-to-batch-or-print';

import OrdersHeader from '../orders-header';
import style from './single-order-header.module.less';
import Global from '../../../../store/global-selectors';
import { getActualSalesOrderIds } from '../../../../store/orders/orders.helpers';
import { emptyArray } from 'ui-components/default-props/empty';
import get from 'lodash.get';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const getSalesOrderNumbers = createSelector(
  (salesOrders) => salesOrders,
  (salesOrders) => salesOrders.map((salesOrder) => salesOrder?.orderNumber).join(', '),
);

const SingleOrder = () => {
  const selectedIds = useSelector(Global.selectSelectedOrdersIds);
  const selectedSalesOrderId = useSelector((state) => getActualSalesOrderIds(state, selectedIds)) || emptyArray;
  const salesOrders =
    useSelector((state) =>
      Global.selectEntitiesSalesOrdersByIds(state, {
        salesOrderIds: selectedSalesOrderId,
      }),
    ) || emptyArray;
  const orderNumbers = getSalesOrderNumbers(salesOrders);
  const marketplaceId = get(salesOrders[0], 'store.marketplaceId', null);
  const externalUrl = get(salesOrders[0], 'store.externalUrl', '');
  const ordersCount = selectedIds.length;
  const isSilentlyLoading = useSelector((state) =>
    Global.selectEntitiesSalesOrderIsLoading(state, {
      salesOrderId: selectedSalesOrderId[0],
    }),
  );

  return (
    <div className={style['single-order-header']}>
      <OrdersHeader
        externalUrl={externalUrl}
        isSilentlyLoading={isSilentlyLoading}
        marketplaceId={marketplaceId}
        orderNumbers={orderNumbers}
        ordersCount={ordersCount}
      />
      <div className={style['header-actions']}>
        <AddOrderToBatchOrPrint />
      </div>
    </div>
  );
};

export default React.memo(SingleOrder);
